import { render, staticRenderFns } from "./WikiParentSelector.vue?vue&type=template&id=f63bd012&"
import script from "./WikiParentSelector.vue?vue&type=script&lang=js&"
export * from "./WikiParentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports